import React from 'react';
import { Modal } from 'antd';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  header,
  content,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  confirmDisabled = false,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={onConfirm}
      title={header}
      okText={confirmText}
      cancelText={cancelText}
      okButtonProps={{ disabled: confirmDisabled }}
      centered
    >
      {typeof content === 'string' ? <p>{content}</p> : content}
    </Modal>
  );
};

export default ConfirmModal;
